module.exports = __webpack_public_path__ + "static/media/chain.838cdc20.svg";